const searchBar = document.querySelector('.detail-search__search-bar');
const clearSearchBar = document.querySelector('.detail-search__search-bar-container .icon--close');

if (searchBar) {
    clearSearchBar.addEventListener('click', () => {
        searchBar.value = '';
    });
}

const searchPage = document.querySelector('.detail-search');
const bodyEl = document.body;

if (searchPage) {
    bodyEl.classList.add('detail-search-page');
}

// Filter Categories
function displayItems() {
    const items = document.querySelectorAll('.detail-search-result-item');

    items.forEach((item, index) => {
        if (index < 6) {
            item.style.display = 'block';
        } else {
            item.style.display = 'none';
        }
    });
}

function showAllItems() {
    const items = document.querySelectorAll('.detail-search-result-item');

    items.forEach((item) => {
        item.style.display = 'block';
    });

    const loadMoreButton = document.querySelector('.detail-search-load-more');
    loadMoreButton.style.display = 'none';
}

const loadMoreButton = document.querySelector('.detail-search-load-more');
if (loadMoreButton) {
    loadMoreButton.addEventListener('click', showAllItems);
}

function filterItems() {
    const selectedCategories = Array.from(document.querySelectorAll('input[name="categories"]:checked')).map(
        (checkbox) => checkbox.value
    );

    if (!selectedCategories) {
        return;
    }

    const items = document.querySelectorAll('.detail-search-result-item');

    items.forEach((item) => {
        const categoryId = item.getAttribute('data-category-id');

        if (selectedCategories.length === 0 || selectedCategories.includes(categoryId)) {
            item.style.display = 'block';
        } else {
            item.style.display = 'none';
        }
    });

    if (selectedCategories.length === 0) {
        showAllItems();
    }
}

const checkboxes = document.querySelectorAll('input[name="categories"]');
checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', filterItems);
});
displayItems();
